import { Edge, Node } from '@xyflow/react';
import { NodeCategoryModel } from 'src/modules/network-configuration/models/node-data';
import {
  IConfigurationQos,
  IConfigurationQosDefault,
} from 'src/types/configuration';

export const configurationQos = ({
  nodeId,
  nodeCategory,
  edges,
  nodes,
}: {
  nodeId: string;
  nodeCategory: NodeCategoryModel;
  edges: Edge[];
  nodes: Node[];
}): IConfigurationQos => {
  const defaultInterface: IConfigurationQos = {
    defaults: [],
    'dscp->pcp': [
      1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 3,
      3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6,
      6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7,
    ],
    'dscp->queue': [
      0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 3,
      3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6,
      6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7,
    ],
    'pcp->queue': [1, 0, 2, 3, 4, 5, 6, 7],
    version: 1,
  };

  const defaultDefaultItem: IConfigurationQosDefault = {
    interface: 0,
    pcp: 0,
    'prio choice': 'default',
    queue: 1,
  };

  const defaultItem: IConfigurationQosDefault[] = [];
  if (!nodeCategory.ports) return defaultInterface;

  for (let i = 0; i < nodeCategory.ports?.length; i += 1) {
    const port = nodeCategory.ports[i];
    // const edge = edges.find(
    //   (e) =>
    //     e.targetHandle === `${nodeId}__${port.id}__target` ||
    //     e.sourceHandle === `${nodeId}__${port.id}__source`,
    // );
    const { portIndexes } = nodeCategory;
    const portIndex = portIndexes[port.id] || 0;
    if (!portIndex) {
      throw new Error('Port index not found');
    }

    const defaultItemData = {
      ...defaultDefaultItem,
      interface: portIndex,
    };

    defaultItem.push(defaultItemData);
  }

  defaultInterface.defaults = defaultItem.sort(
    (a, b) => a.interface - b.interface,
  );

  return defaultInterface;
};
